import React from "react";
// import MetaTags from "react-meta-tags";

// Components
import { PageHeading } from "../components/PageHeading";
import { ServicePageWrapper } from "styling/ServicePagesStyling";
import { LinkToPage } from "../components/LinkToPage";

export const ActionPlan = () => {
  return (
    <>
      {/* <MetaTags>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>We Exist - Action Plan</title>
        <meta
          name="description"
          content="Vi hjälper er sätta en plan för ert jämställdhetsarbete baserat på era mål och ambitioner."
        />
        <meta property="og:title" content="We Exist - Action Plan" />
        <meta
          property="og:description"
          content="Vi hjälper er sätta en plan för ert jämställdhetsarbete baserat på era mål och ambitioner."
        />
        <meta property="og:image" content="service-images/rekrytering.jpg" />
      </MetaTags> */}

      <PageHeading title="Action Plan" />
      <ServicePageWrapper>
        <img src="./service-images/action-plan.jpg" alt="möte kontor" />
        <p>
          Vi tittar på det långsiktiga arbetet när det kommer till jämställdhet
          på ert företag. Efter att vi har kartlagt och samlat data över var ni
          är idag så lägger vi en plan framöver. Vad är era mål och ambitioner
          när det kommer till jämställdheten på ert företag? Vill ni att fler
          kvinnliga kandidater ska söka till era tjänster som ligger ute? Eller
          vill ni kanske se till att färre kvinnliga medarbetare slutar? Eller
          vad är viktigast för er? Inga drömmar är för små eller stora och vi på
          We Exist hjälper mer än gärna till att uppnå dem!
        </p>

        <LinkToPage location="/for-foretag" text="Kontakta We Exist" />
      </ServicePageWrapper>
    </>
  );
};
